import React from 'react';

const StepByStepOverview = () => {
  return (
    <React.Fragment>
      <h1>Step-by-Step Overview</h1>
      <p>Upon accepting an invitation to review an article, each reviewer is assigned a Greek letter used by the author for identification purposes (e.g. Reviewer Alpha). This ensures that all Cureus reviewers are completely anonymous. All peer review is conducted within our custom-built online editing tool. Here’s how the process works.</p>
      <ol className='decimals indented-for-medium-up'>
        <li>
          <p>You’ll receive an email invitation that includes the article’s title, author, categories and abstract. Two buttons are available: “Accept review” and “Decline review.” Selecting “Accept review” will take you to review mode. Selecting “Decline review” will notify the article’s submitting author and Cureus editors.</p>
        </li>
        <li>
          <p>Once in review mode, highlight text to leave your comments. When you’re finished adding comments to the text, click the “Submit review” button to proceed to the peer review questionnaire before submitting your review.</p>
          <ul className='alpha space-top-m'>
            <li>
              <p>If you are not ready to proceed to the questionnaire, click the “Save and exit” button to return to the My Reviews tab of your dashboard. (Clicking “Save and exit” does not submit the review.)</p>
            </li>
            <li>
              <p>You may re-enter review mode at any time by selecting “Continue my review” in the My Reviews tab of your dashboard or by clicking “Accept review” in the original email invitation (as mentioned in Step 1).</p>
            </li>
          </ul>
        </li>
        <li>
          <p>The peer review questionnaire begins with two questions sent to both the submitting author and the editor:</p>
          <ol className='alpha space-top-m'>
            <li>
              <p>Provide a brief summary of the main research question, claims, and conclusions of the study. How does this research fit within the existing literature?</p>
            </li>
            <li>
              <p>Provide a brief assessment of the research process and presentation while noting any obvious flaws or areas of weakness. Are the conclusions consistent with the evidence presented?</p>
            </li>
          </ol>
          <p>The remaining three questions are sent only to the editor:</p>
          <ol className='alpha space-top-m' start='3'>
            <li>
            <p>Please provide your quality assessment of this article. (1=Lowest, 2=Low, 3=Average, 4=High, 5=Highest)</p>
            </li>
            <li>
              <p>Is the science and any associated conclusions contained within this article credible and potentially valuable?</p>
              <ol className='disc'>
                <li>
                  <p>Yes (accept after revisions)</p>
                </li>
                <li>
                  <p>Decision pending (please send for re-review after revisions)</p>
                </li>
                <li>
                  <p>No (do not publish)</p>
                </li>
              </ol>
            </li>
            <li>
              <p>Add confidential comments for our editors, including any potential ethical concerns, as well as whether you are willing to review a revised version if needed (optional).</p>
            </li>
          </ol>
        </li>
        <li>
          <p>Finally, you’ll then be asked to disclose any potential conflicts of interest before submitting your review.</p>
        </li>
      </ol>
    </React.Fragment>
  )
}

export default StepByStepOverview;